import { jsx as _jsx } from "react/jsx-runtime";
import { SearchDefaultIcon } from "@jti/brand-icons/search-default";
import { SearchFullIcon } from "@jti/brand-icons/search-full";
import styles from "./SearchHeaderButton.module.scss";
export const SearchHeaderButton = ({ isOpened, onClose, onOpen }) => {
    const toggle = (isOpened) => {
        if (isOpened) {
            onClose();
        }
        else {
            onOpen();
        }
    };
    return (_jsx("div", { "data-search-button": true, "data-testid": "search", children: _jsx("button", { type: "button", "aria-label": "searchButton", onClick: () => toggle(isOpened), className: styles.searchButton, children: _jsx("span", { className: styles.searchIcon, children: isOpened ? (_jsx(SearchFullIcon, { className: styles.searchIcon })) : (_jsx(SearchDefaultIcon, { className: styles.searchIcon })) }) }) }));
};
//# sourceMappingURL=SearchHeaderButton.js.map